import React from "react"
import styled from "styled-components"
import PropTypes from 'prop-types'
import Line from './line'

const Title = styled.h3`
  font-size: 0.99rem;
  font-weight: 600;
  /* text-align: center; */
  text-align: left;
  @media(min-width: 646px) {
    
  }
  & + div {
    align-self: flex-start;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  @media(min-width: 646px) {
    text-align: left;
    align-items: flex-start;
  }
`
const MenuTitle = ({ title }) => (
 <Container>
   <Title>{title}</Title>
   <Line width="10px" align="flex-start" />
 </Container>
)

MenuTitle.propTypes = {
  title: PropTypes.string.isRequired,
}
export default MenuTitle
